<template>
  <div id="notice">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl()">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        公示栏
        <!-- <img src="@/assets/logo.png" width="21" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>-->
      </div>
      <!-- <div class="right" @click="toUrl('/index')">
        <van-icon name="wap-home" size="21" />
      </div> -->
    </div>
    <div class="padding">
     <van-loading type="spinner" v-show="showL" />
      <van-tabs
       v-show="!showL"
        v-model="active"
        swipeable
        title-active-color="#000000"
        title-inactive-color="#B2B2B2"
        @click="toList"
      >
        <van-tab  v-for="(item,index) in category" :key="index" :title="item.name" :name="item.id">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="notice-lists" v-for="(item,index) in news" :key="index" @click="toInfo(item.id,1,item.url)">
              <div class="notice-list">
                <div class="list-tit">{{item.title}}</div>
                <div class="list-icon">
                  <van-icon name="arrow" size="20" color="#79CA50" />
                </div>
              </div>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import { Icon, Tab, Tabs, PullRefresh, List,Loading } from "vant";
import { article, articleCategory ,view} from "@/api/apiData";
export default {
  components: {
    [Icon.name]: Icon,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Loading.name]: Loading,
  },
  data() {
    return {
      active: 0,
      category: [],
      catid: "",
      info: [],
      news: [],
      isLoading: false,
      totalPages: 1,
      padding: false,
      loading: false,
      finished: false,
      page: 0,
      showL:true
    };
  },
  mounted() {
    this.getCategory();
  },
  methods: {
    toUrl() {
      // this.$router.push(u);
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
    },
     toInfo(id, t, url) {
      // console.log(888)
       view({ id: id }).then((res) => {});
      if (url == "") {
        this.$router.push({
          path: "/noticeInfo",
          query: {
            id: id,
            type: t,
          },
        });
      }else{
        window.location.href = url;
      }
    },
    getCategory() {
      articleCategory().then((res) => {
        this.category = res.data;
        this.catid = res.data[0].id;
        this.showL = false
      });
    },
    toList(name, title) {
      this.catid = name;
      var that = this;
      that.news = [];
      that.page = 0;
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.getNewsList();
      setTimeout(() => {
        that.refreshing = false;
        // Toast("刷新成功");
        that.isLoading = false;
      }, 1500);
    },
    // 下拉加载
    onLoad() {
      this.getNewsList();
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      // 清空列表数据
      var that = this;
      that.news = [];
      that.page = 0;
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.getNewsList();
      setTimeout(() => {
        that.refreshing = false;
        // Toast("刷新成功");
        that.isLoading = false;
      }, 1500);
    },
    getNewsList() {
      var that = this;
      var news = this.news;
      var page = this.page + 1;
      var totalPages = this.totalPages;
      var param = {
        page: page,
        pageSize: 5,
        catid: this.catid,
      };
      if (totalPages >= page) {
        article(param).then((res) => {
          //////console.log(res);
          if (res.status == 1) {
            if (res.data.data.length < 4) {
              this.padding = false;
            }
            that.page = page;
            that.news = news.concat(res.data.data);
            that.totalPages = Math.ceil(
              Number(res.data.total) / res.data.data.length
            );
            if (res.data.data.length == 0) {
              //数据请求成功 但是无数据
              that.finished = true;
              that.loading = false;
              return false;
            }
            if (that.news.length >= news.length) {
              // 数据请求成功后  停止加载状态
              setTimeout(() => {
                that.loading = false;
              }, 1500);
            }
          } else {
            //登录失败
            // Toast(res.message);
          }
        });
      } else {
        // 全部数据加载完毕
        that.finished = true;
      }
    },
  },
};
</script>
<style scoped>
.notice {
  border-top: solid 4px #f5f5f5;
  margin-top: 1.3rem;
  /* margin-bottom: 1.5rem; */
  padding-top: 1.3rem;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}
.notice-tit {
  display: flex;
}
.notice-tit-more {
  /* display: flex; */
  width: 20%;
  color: #ababab;
  text-align: right;
  align-self: center;
  font-size: 0.8rem;
}
.more-icon {
  color: #ababab;
  padding-top: 5px;
}
.notice-tit-text {
  font-size: 1.2rem;
  font-weight: bold;
  width: 80%;
  text-align: left;
  position: relative;
}
.notice-tit-text:after {
  content: "";
  /* margin: 0 auto; */
  position: absolute;
  bottom: -14rpx;
  left: 0.7rem;
  /* right: 0; */
  height: 6px;
  width: 2.5rem;
  background-color: #79ca50;
  bottom: 0px;
  z-index: -1;
  border-radius: 5px;
}
/* .notice-lists {
  margin-top: 1rem;
} */
.notice-list {
  display: flex;
  font-size: 0.9rem;
  /* border: solid 1px #C1C1C1; */
  box-shadow: 0px 0px 3px 0px rgb(193 193 193 / 54%);
  padding: 0.5rem;
}
.list-tit {
  width: 90%;
  text-align: left;
  color: black;
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-icon {
  width: 10%;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/page/notice.vue